export const IMAGE_URL = process.env.NEXT_PUBLIC_IMAGE_URL as string;

export const ENV = {
  NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
  BACKEND_URL: process.env.BACKEND_URL,
} as const;
